import { action, makeObservable, observable } from 'mobx'
import { greaterThanOrEqual } from 'utils/validation-utils'
import { required, validationContext } from 'validx'
import {
  IInventoryItemPricingEditor,
  InventoryItemFeeValues,
  InventoryItemPricingValues,
} from './inventory-item-pricing-editor'
import { InventoryItemPricing } from 'admin/inventory/InventoryItem'

/**
 * View Model for Inventory Items of type Fee.
 */
export class FeeEditorViewModel implements IInventoryItemPricingEditor {
  /**
   * The chosen fee.
   */
  fee = 0

  /**
   * The validation context.
   */
  validation = validationContext(this, {
    fee: [
      required('A fee amount is required.'),
      greaterThanOrEqual(0, 'A fee must be 0 or greater.'),
    ],
  })

  constructor() {
    makeObservable(this, {
      fee: observable,
      hydrate: action.bound,
      reset: action.bound,
    })
  }

  /**
   * @inheritdoc
   */
  validate(): boolean {
    return this.validation.reset().validate().isValid
  }

  /**
   * @inheritdoc
   */
  hydrate(values: InventoryItemFeeValues): void {
    this.fee = values.fee
  }

  /**
   * @inheritdoc
   */
  toValues(): InventoryItemPricingValues {
    return {
      type: InventoryItemPricing.Fee,
      fee: this.fee,
    }
  }

  /**
   * @inheritdoc
   */
  reset() {
    this.fee = 0
    this.validation.reset()
  }
}
